import { create } from "zustand"

import { ANALYTIC_EVENTS, trackAnalyticEvent } from "../../../../util/analytics"

interface SessionModalStore {
  isOpen: boolean
  onOpen: (sessionBookingId: number) => void
  onClose: () => void
  sessionBookingId: number | null
  sessionMarkedAsCompleted: boolean
  setSessionMarkedAsCompleted: (sessionMarkedAsCompleted: boolean) => void
  isWritingManualNotes: boolean
  setIsWritingManualNotes: (isWritingManualNotes: boolean) => void
}

const initialState = {
  sessionBookingId: null,
  isOpen: false,
  sessionMarkedAsCompleted: false,
  isWritingManualNotes: false,
}

const useSessionModalStore = create<SessionModalStore>((set) => ({
  ...initialState,
  onOpen: (sessionBookingId: number) => {
    trackAnalyticEvent(ANALYTIC_EVENTS.MARK_SESSION_AS_MODAL, {
      sessionBookingId,
    })
    set({ sessionBookingId, isOpen: true })
  },
  onClose: () => set(initialState),
  setSessionMarkedAsCompleted: (sessionMarkedAsCompleted: boolean) =>
    set({ sessionMarkedAsCompleted }),
  setIsWritingManualNotes: (isWritingManualNotes: boolean) =>
    set({ isWritingManualNotes }),
}))

export default useSessionModalStore
